// Presentation entry is available on Dev and local frontend previews only.
export const isDemoSite = ["dev-teacher.sportarc.cn", "127.0.0.1", "localhost", "[::1]"].includes(window.location.hostname);
